export const NgZorroIcons = [
  'account-book',
  'alert',
  'api',
  'appstore',
  'audio',
  'bank',
  'bell',
  'book',
  'box-plot',
  'bug',
  'build',
  'bulb',
  'calculator',
  'calendar',
  'camera',
  'car',
  'carry-out',
  'check-circle',
  'check-square',
  'ci-circle',
  'ci',
  'clock-circle',
  'close-circle',
  'close-square',
  'cloud',
  'code',
  'compass',
  'contacts',
  'container',
  'control',
  'copy',
  'copyright-circle',
  'copyright',
  'credit-card',
  'crown',
  'customer-service',
  'dashboard',
  'database',
  'delete',
  'diff',
  'dislike',
  'dollar-circle',
  'dollar',
  'down-circle',
  'down-square',
  'edit',
  'environment',
  'euro-circle',
  'euro',
  'exclamation-circle',
  'experiment',
  'eye-invisible',
  'eye',
  'file-add',
  'file-excel',
  'file-exclamation',
  'file-image',
  'file-markdown',
  'file-pdf',
  'file-ppt',
  'file-text',
  'file',
  'file-unknown',
  'file-word',
  'file-zip',
  'filter',
  'fire',
  'flag',
  'folder-add',
  'folder-open',
  'folder',
  'frown',
  'fund',
  'funnel-plot',
  'gift',
  'gold',
  'hdd',
  'heart',
  'highlight',
  'home',
  'hourglass',
  'html5',
  'idcard',
  'info-circle',
  'insurance',
  'interaction',
  'layout',
  'left-circle',
  'left-square',
  'like',
  'lock',
  'mail',
  'medicine-box',
  'meh',
  'message',
  'minus-circle',
  'minus-square',
  'mobile',
  'money-collect',
  'notification',
  'pause-circle',
  'phone',
  'picture',
  'pie-chart',
  'play-circle',
  'play-square',
  'plus-circle',
  'plus-square',
  'pound-circle',
  'printer',
  'profile',
  'project',
  'property-safety',
  'pushpin',
  'question-circle',
  'reconciliation',
  'red-envelope',
  'rest',
  'right-circle',
  'right-square',
  'rocket',
  'safety-certificate',
  'save',
  'schedule',
  'security-scan',
  'setting',
  'shop',
  'shopping',
  'skin',
  'sliders',
  'smile',
  'snippets',
  'sound',
  'star',
  'stop',
  'switcher',
  'tablet',
  'tag',
  'tags',
  'thunderbolt',
  'tool',
  'trademark-circle',
  'trophy',
  'unlock',
  'up-circle',
  'up-square',
  'usb',
  'video-camera',
  'wallet',
  'warning',
];
